module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-login"
  }, [_c('a', {
    attrs: {
      "href": "/tt"
    }
  }, [_c('span', [_vm._v("\n                    Войти\n                ")]), _vm._v(" "), _c('GPlus')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('span', {
    staticClass: "header-content-txt"
  }, [_vm._v("Еще один таск трекер?")]), _vm._v(" "), _c('div', {
    staticClass: "header-content-logo"
  }, [_c('HeaderLogo')], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('affix', {
    ref: "nav",
    staticClass: "navbar navbar-default",
    attrs: {
      "relative-element-selector": "#main",
      "offset": {
        top: 52,
        bottom: 0
      }
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "collapse"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openMenu = !_vm.openMenu
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": ""
    }
  }, [_c('HeaderLogo')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbar-collapse-1",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('scrollactive', {
    staticClass: "nav navbar-nav",
    attrs: {
      "active-class": "active",
      "offset": 200,
      "duration": 1000,
      "bezier-easing-value": ".5,0,.35,1"
    }
  }, [_c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#header"
    }
  }, [_vm._v("Главная")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#features"
    }
  }, [_vm._v("Преимущества")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#overview"
    }
  }, [_vm._v("Возможности")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#gallery"
    }
  }, [_vm._v("Галерея")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#download"
    }
  }, [_vm._v("Подписаться")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#donate"
    }
  }, [_vm._v("Поддержать")])]), _vm._v(" "), _c('li', {
    class: {
      collapsed: _vm.openMenu == false
    },
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": _vm.openMenu ? true : false
    }
  }, [_c('a', {
    staticClass: "scrollactive-item",
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("Контакты")])])]), _vm._v(" "), _c('div', {
    staticClass: "header-lang"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("EN")]), _vm._v(" "), _c('a', {
    staticClass: "active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("RU")])])], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "header-content-txt"
  }, [_vm._v("Да, и возможности — "), _c('span', [_vm._v("огонь!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1251f6ab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Header.vue
// module id = 1226
// module chunks = 1